import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVeeamComponent } from './simple-icons-veeam.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVeeamComponent ],
    exports:      [ SimpleIconsVeeamComponent ],
    bootstrap:    []
})
export class SimpleIconsVeeamModule {}
